module.exports = __webpack_public_path__ + "media/images/icons/material/sent-8ba11bbf6eeac1d31b0e69ab1ea3e713.svg";